export default __webpack_public_path__ + "static/media/043-heart monitoring.56fa7f86.svg";